import type { Result } from '@/types/Activity'

enum Statusvalues {
  Fail = 0,
  Pass = 1,
  AwaitingResponse = 2,
  AwaitingReview = 3,
  Rejected = 4,
  ConditionalPass = 5,
}

const FailStatusTypes = [
  Statusvalues.Fail,
  Statusvalues.AwaitingReview,
  Statusvalues.AwaitingResponse,
  Statusvalues.Rejected,
]

const SuccessStatusTypes = [Statusvalues.Pass, Statusvalues.ConditionalPass]

// Different Status types can be found below
// https://github.com/vouchdevhub/func-core-rules-engine/blob/a6f513391c75ea49147f3b9c513feaf75ce0dd1e/func-rules-engine/Vouch.Rules.Engine/Models/ResultPropertyStatus.cs#L4

export function displayFailReasons(
  results: Result[],
  label: string,
  propertyName?: string,
): string[] {
  const failureReasons: string[] = []
  // eslint-disable-next-line array-callback-return
  results.map(section => {
    if (
      section.name === label &&
      section.outcome !== 1 &&
      section.properties !== undefined &&
      section.properties !== null &&
      section.properties.length > 0
    ) {
      // eslint-disable-next-line array-callback-return
      return section?.properties.map(item => {
        if (
          isFailStatus(item.result) &&
          item.decisionInfo !== undefined &&
          item.decisionInfo !== null &&
          item.decisionInfo.length > 0 &&
          (propertyName === undefined || item.name === propertyName)
        ) {
          failureReasons.push(item.decisionInfo[0])
        }
      })
    }
  })
  return failureReasons
}

export function displaySuccessReasons(
  results: Result[],
  label: string,
  propertyName?: string,
): string[] {
  const successReasons: string[] = []
  // eslint-disable-next-line array-callback-return
  results.map(section => {
    if (
      section.name === label &&
      section.outcome !== 0 &&
      section.properties !== undefined &&
      section.properties !== null &&
      section.properties.length > 0
    ) {
      // eslint-disable-next-line array-callback-return
      return section?.properties.map(item => {
        if (
          isSuccessStatus(item.result) &&
          item.decisionInfo !== undefined &&
          item.decisionInfo !== null &&
          item.decisionInfo.length > 0 &&
          (propertyName === undefined || item.name === propertyName)
        ) {
          successReasons.push(item.decisionInfo[0])
        }
      })
    }
  })
  return successReasons
}

function isSuccessStatus(status?: number) {
  let isSuccess = false

  if (Number.isInteger(status) && status !== undefined) {
    isSuccess = SuccessStatusTypes.includes(status)
  }

  return isSuccess
}

function isFailStatus(status?: number) {
  let isFail = false

  if (Number.isInteger(status) && status !== undefined) {
    isFail = FailStatusTypes.includes(status)
  }

  return isFail
}
